import React from 'react';
import { pdf } from '@react-pdf/renderer';
import TreatmentPDF from '../pdf/TreatmentPDF';
import { getOrganizationCurrency } from './currencyUtils';

export async function createTreatmentBlob(treatment) {
  if (!treatment) throw new Error('Treatment data is required for PDF');
  const [currency, organization, clinic] = [
    await getOrganizationCurrency(),
    treatment?.organization || null,
    treatment?.clinic || treatment?.patient?.registeredClinic || null
  ];
  const instance = pdf(
    <TreatmentPDF
      treatment={treatment}
      organization={organization}
      clinic={clinic}
      currency={currency}
    />
  );
  const blob = await instance.toBlob();
  return blob;
}

export async function downloadTreatmentPDF(treatment) {
  try {
    const blob = await createTreatmentBlob(treatment);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const fileName = `Treatment_${treatment.code || treatment._id || 'TREAT'}_${(treatment.patient?.name || treatment.name || 'Treatment').replace(/\s+/g,'_')}.pdf`;
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Treatment PDF download error:', err);
    throw new Error(err?.message || 'Failed to generate treatment PDF');
  }
}

export async function openTreatmentPDF(treatment) {
  try {
    const blob = await createTreatmentBlob(treatment);
    const url = URL.createObjectURL(blob);
    const w = window.open(url, '_blank');
    if (!w) throw new Error('Popup blocked. Allow popups for this site to print.');
  } catch (err) {
    console.error('Treatment PDF open error:', err);
    throw new Error(err?.message || 'Failed to generate treatment PDF');
  }
}
